import React from "react";

import TeamTable from "components/Cards/TeamTable";

export default function Team() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <TeamTable />
        </div>
      </div>
    </>
  );
}
